import { Content } from 'pages/Content';

export const ImportantWarnings = () => {
  return (
    <Content
      showHeaderCarrossel
      title='Avisos Importantes'
      document='avisos_importantes'
      description='Comunicados e informações relevantes sobre as marcas, lojas e produtos.'
    />
  );
};
